import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/AboutView.vue')
  },
  {
    path: '/app/terms',
    name: 'appTerms',
    component: () =>
      import(/* webpackChunkName: "app-word" */ '@/views/app/terms.vue')
  },
  {
    path: '/app/policy',
    name: 'appPolicy',
    component: () =>
      import(/* webpackChunkName: "app-word" */ '@/views/app/policy.vue')
  },
  {
    path: '/app/shared',
    name: 'appShared',
    component: () =>
      import(/* webpackChunkName: "app-word" */ '@/views/app/shared.vue')
  },
  {
    path: '/app/qa',
    name: 'appQa',
    component: () =>
      import(/* webpackChunkName: "app-word" */ '@/views/app/qa.vue')
  },
  {
    path: '/lxb/terms',
    name: 'lxbTerms',
    component: () =>
      import(
        /* webpackChunkName: "liexiaobao-word" */ '@/views/liexiaobao/terms.vue'
      )
  },
  {
    path: '/lxb/policy',
    name: 'lxbPolicy',
    component: () =>
      import(
        /* webpackChunkName: "liexiaobao-word" */ '@/views/liexiaobao/policy.vue'
      )
  },
  {
    path: '/lxb/shared',
    name: 'lxbShared',
    component: () =>
      import(
        /* webpackChunkName: "liexiaobao-word" */ '@/views/liexiaobao/shared.vue'
      )
  },
  {
    path: '/lxb/qa',
    name: 'lxbQa',
    component: () =>
      import(
        /* webpackChunkName: "liexiaobao-word" */ '@/views/liexiaobao/qa.vue'
      )
  },
  {
    path: '/lxb/promotion',
    name: 'lxbPromotion',
    component: () =>
      import(
        /* webpackChunkName: "liexiaobao-word" */ '@/views/liexiaobao/promotion.vue'
      )
  },
  {

    path: '/agreement',
    name: 'agreement',
    component: () =>
      import(
        /* webpackChunkName: "agreement" */ '@/views/agreement/index.vue'
      ),
    children: [
      {
        path: 'history',
        name: 'agreementHistory',
        component: () =>
          import(
        /* webpackChunkName: "agreement" */ '@/views/agreement/history.vue'
          )
      },
      {
        path: 'docx',
        name: 'agreementDocx',
        component: () => import(
        /* webpackChunkName: "agreement" */ '@/views/agreement/docx.vue'
        )
      },
      {
        path: ':versionId?',
        name: 'agreementContent',
        component: () =>
          import(
        /* webpackChunkName: "agreement" */ '@/views/agreement/content.vue'
          )
      }
    ]
  },
  {
    path: '/app-web/:appId',
    name: 'AppWeb',
    component: () =>
      import(/* webpackChunkName: "app-page" */ '@/views/app-web/index.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
